export const stringFilterKeys = [
    { value: "contains", label: "Contains" },
    { value: "exclude", label: "Doesn't Contain" },
    { value: "string_equals", label: "Equals" },
    { value: "unequals", label: "Doesn't Equal" },
    { value: "begins_with", label: "Begins With" },
    { value: "ends_with", label: "Ends With" },
    { value: "not_null", label: "Not Null" },
    { value: "null", label: "Null" },
    { value: "count_gt_1", label: "Count > 1" },
    { value: "like", label: "Like" }
];
export const dateFilterKeys = [
    { value: "in_between", label: "In between" },
    { value: null, label: null },
    { value: "yesterday", label: "Yesterday" },
    { value: "last_month", label: "Last Month" },
    { value: "today", label: "Today" },
    { value: "this_month", label: "This Month" },
    { value: "tomorrow", label: "Tomorrow" },
    { value: "next_month", label: "Next Month" },
    { value: "last_week", label: "Last Week" },
    { value: "last_year", label: "Last Year" },
    { value: "this_week", label: "This Week" },
    { value: "this_year", label: "This Year" },
    { value: "next_week", label: "Next Week" },
    { value: "next_year", label: "Next Year" }
];
export const numberFilterKeys = config => {
    const { hasTopNFilter = false } = config || {};
    const filters = [
        { value: "equals", label: "Equals" },
        { value: "unequals", label: "Doesn't Equal" },
        { value: "less_than", label: "Less Than" },
        { value: "less_than_or_equal", label: "Less Than or Equal to" },
        { value: "greater_than", label: "Greater Than" },
        { value: "greater_than_or_equal", label: "Greater Than or Equal to" },
        ...(hasTopNFilter ? [{ value: "top_n", label: "Top N" }] : []),
        { value: "not_null", label: "Not Null" },
        { value: "null", label: "Null" },
        { value: "count_gt_1", label: "Count > 1" },
        { value: "like", label: "Like" }
    ];
    return filters;
};
export const commonDateFilterKeys = [
    { value: "in_between", label: "In between" },
    { value: null, label: null },
    { value: "yesterday", label: "Yesterday" },
    { value: "last_month", label: "Last Month" },
    { value: "today", label: "Today" },
    { value: "this_month", label: "This Month" },
    { value: "last_week", label: "Last Week" },
    { value: "last_year", label: "Last Year" },
    { value: "this_week", label: "This Week" },
    { value: "this_year", label: "This Year" }
];

const isNumericFieldType = fieldType => fieldType === "number" || fieldType === "year";
const isDateFieldTypeValue = fieldType => fieldType === "date" || fieldType === "date_time";

export const getWildcardFilterKeysForFieldType = (fieldType, fieldConfig = {}) => {
    if (isDateFieldTypeValue(fieldType)) return dateFilterKeys;
    if (isNumericFieldType(fieldType)) return numberFilterKeys(fieldConfig);
    return stringFilterKeys;
};

export const getWildcardFilterOperatorLabel = (operatorKey, fieldType, fieldConfig = {}) => {
    if (!operatorKey) return "";
    const filterKeys = getWildcardFilterKeysForFieldType(fieldType, fieldConfig);
    return filterKeys.find(item => item.value === operatorKey)?.label || operatorKey;
};

/** Human-readable tag value for an applied wildcard filter (e.g. "0 [Greater Than or Equal to]"). */
export const formatAppliedWildcardFilterDisplayValues = (wValue, fieldType, fieldConfig = {}) => {
    if (!wValue?.filters?.length) {
        return [`${wValue?.key || ""}`];
    }
    const operatorLabels = wValue.filters
        .map(op => getWildcardFilterOperatorLabel(op, fieldType, fieldConfig))
        .filter(Boolean)
        .join(", ");

    if (isDateFieldTypeValue(fieldType)) {
        return [`${operatorLabels} ${wValue?.key?.from}-${wValue?.key?.to}`];
    }
    return [`${wValue?.key || ""} [${operatorLabels}]`];
};

/** Whether a stored wildcard filter entry should apply, count, or display. */
export const isAppliedWildcardFilterEntry = entry => {
    if (!entry?.filters?.length) return false;
    const filterType = entry.filters[0];
    if (filterType === "in_between") return !!(entry?.key?.from && entry?.key?.to);
    if (filterType === "null" || filterType === "not_null" || filterType === "count_gt_1") return true;
    return !!(typeof entry.key === "string" && entry.key.trim().length);
};
